var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListChecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_280",
    "data-name": "Rectangle 280",
    width: 16,
    height: 16,
    transform: "translate(174.932 12)",
    fill: "#fff",
    stroke: "#ff0078",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5863e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8789fb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_78",
    "data-name": "Mask Group 78",
    transform: "translate(-174.932 -12)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(174.932 12.572)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_895",
    "data-name": "Group 895",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M4.286,17.428a1.714,1.714,0,0,1-1.714-1.714V4.286A1.714,1.714,0,0,1,4.286,2.571h9.142a.571.571,0,0,1,0,1.143H4.286a.571.571,0,0,0-.571.571V15.714a.571.571,0,0,0,.571.571H15.714a.571.571,0,0,0,.571-.571V10a.571.571,0,0,1,1.143,0v5.714a1.714,1.714,0,0,1-1.714,1.714Z",
    transform: "translate(-2.571 -2.571)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M12.118,13.261l8-8a.572.572,0,1,0-.809-.809l-7.6,7.6L8.69,9.023a.572.572,0,0,0-.809.809l3.428,3.428a.571.571,0,0,0,.809,0Z",
    transform: "translate(-4.285 -3.142)",
    fill: "url(#linear-gradient)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListChecked);
export default __webpack_public_path__ + "static/media/listChecked.d4a188e7bcaa76a047817ebd5b1fc9df.svg";
export { ForwardRef as ReactComponent };